import {AdminRuntimeEnvProfile} from '../enum/AdminRuntimeEnvProfile'
import {IAdminRuntimeEnvOverrides} from '../types/IAdminRuntimeEnvOverrides'
import {IAdminRuntimeState} from '../types/IAdminRuntimeState'
import {getAdminRuntimePreset} from './getAdminRuntimePreset'
import {pickOverridableFromEnv} from './pickOverridableFromEnv'

export function resolveAdminRuntimeOverrides(state: IAdminRuntimeState): IAdminRuntimeEnvOverrides {
  if(state.profile === AdminRuntimeEnvProfile.Inherit) {
    return {}
  }
  if(state.profile === AdminRuntimeEnvProfile.Custom) {
    return {
      ...pickOverridableFromEnv(),
      ...state.overrides,
    }
  }
  return {
    ...pickOverridableFromEnv(),
    ...getAdminRuntimePreset(state.profile),
    ...state.overrides,
  }
}
